import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Injectable()
export class ItemService {
  constructor(private http: HttpClient) {}

  addItem(name, price) {
    const uri = 'http://localhost:4000/items/add';
    const obj = {
      name: name,
      price: price
    };
    this.http.post(uri, obj).subscribe((res) => console.log('Done'));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/item.service.ts